export const INSTANCE_PATH = 'user_positions';
